export const LOADER_STATUS = 'boilderplate/Gstr1New/Save/LOADER_STATUS';
export const PREVIEW_TABLE_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/PREVIEW_TABLE_DATA';
export const SAVE_TABLE_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/SAVE_TABLE_DATA';
export const COMPARATIVE_TABLE_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/COMPARATIVE_TABLE_DATA';




